import { Box, Text, Flex } from '@chakra-ui/react';
import { HiOutlinePlusSmall } from 'react-icons/hi2';

import { useSelector } from 'react-redux';

import ContactItem from './ContactItem';

const SocialInfo = () => {
  const activeProspect = useSelector((s) => s?.conversation?.activeProspect);

  if (activeProspect?.socialInformation)
    return (
      <Box>
        <Flex justifyContent="space-between" px={3} pb={3}>
          <Text fontSize={12} fontWeight={600} color="orange.primary">
            Social Links
          </Text>
        </Flex>
        {activeProspect?.socialInformation.length > 0 &&
          activeProspect?.socialInformation.map((item, index) => (
            <ContactItem
              key={index}
              socialType={item.socialChannel || 'N/A'}
              socialLink={item.socialLink || 'N/A'}
              type="social"
            />
          ))}
      </Box>
    );
};
export default SocialInfo;
